/* eslint-disable camelcase, max-len */

/**
 * These vars list all the current category pages.
 * The purpose of this object is to configure the viable categories per location.
 * Below, arrays of variables are used to reduce file size, allowing optimisation by minification.
 */

const ALL = 'all-events';

const RUN = 'running-events';
const RUN_5K = 'running-events/5k';
const RUN_10K = 'running-events/10k';
const RUN_HM = 'running-events/half-marathon';
const RUN_MARATHON = 'running-events/marathon';
const RUN_ULTRA = 'running-events/ultramarathon';
const RUN_BEGINNER = 'running-events/beginner-friendly';
const RUN_ALL = [ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_10K, RUN_HM, RUN_MARATHON, RUN_ULTRA];
const RUN_SHORT = [ALL, RUN, RUN_5K, RUN_10K, RUN_BEGINNER];
const RUN_MIDDLE = [ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_10K, RUN_HM];
const RUN_LONG = [ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_10K, RUN_HM, RUN_MARATHON];

const TRI = 'triathlon-events';
// const TRI_SUPER = 'triathlon-events/super-sprint';
const TRI_SPRINT = 'triathlon-events/sprint';
const TRI_OLYMPIC = 'triathlon-events/olympic';
const TRI_HI = 'triathlon-events/half-ironman';
// const TRI_IRONMAN = 'triathlon-events/ironman';
const TRI_BEGINNER = 'triathlon-events/beginner-friendly';
// const TRI_ALL = [TRI, TRI_SUPER, TRI_SPRINT, TRI_BEGINNER, TRI_OLYMPIC, TRI_HI, TRI_IRONMAN];
const TRI_SHORT = [TRI, TRI_SPRINT, TRI_BEGINNER];

const CYCLING = 'road-cycling-events';
const OCR = 'obstacle-course-events';
const SWIMMING = 'swimming-events';
const MTB = 'mountain-biking-events';
const DUATHLON = 'duathlon-events';
// const SWIMRUN = 'swimrun-events';

// const ALL_CATEGORIES = [CYCLING, OCR, SWIMMING, MTB, DUATHLON, SWIMRUN, ALL].concat(...RUN_ALL, ...TRI_ALL);

const categoriesByLocation = {
  // GB locations
  aberdeen: [].concat(ALL, RUN, RUN_10K),
  ayr: [].concat(ALL),
  bath: [].concat(RUN_MIDDLE, TRI, OCR, DUATHLON),
  belfast: [].concat(RUN_SHORT),
  birmingham: [].concat(RUN_LONG, CYCLING, ...TRI_SHORT, OCR),
  blackpool: [].concat(RUN_LONG, CYCLING, ...TRI_SHORT),
  bournemouth: [].concat(RUN_LONG, CYCLING, TRI),
  bradford: [].concat(RUN_ALL, CYCLING, TRI),
  brighton: [].concat(RUN_LONG, CYCLING, TRI, TRI_OLYMPIC, OCR, MTB),
  bristol: [].concat(RUN_MIDDLE, CYCLING, TRI, DUATHLON),
  cambridge: [].concat(RUN_ALL, CYCLING, DUATHLON),
  cardiff: [].concat(RUN_LONG, CYCLING),
  carlisle: [].concat(RUN_MIDDLE, CYCLING, TRI),
  chester: [].concat(RUN_LONG, CYCLING, ...TRI_SHORT, OCR),
  coventry: [].concat(RUN_LONG, CYCLING, ...TRI_SHORT, OCR),
  dover: [].concat(RUN_LONG),
  dumfries: [].concat(ALL, RUN, RUN_10K),
  dundee: [].concat(ALL),
  edinburgh: [].concat(RUN_MIDDLE, CYCLING, OCR),
  exeter: [].concat(RUN_MIDDLE, CYCLING, TRI, TRI_HI),
  'fort-william': [].concat(ALL, RUN, RUN_ULTRA, MTB),
  glasgow: [].concat(ALL, RUN, RUN_10K, RUN_HM, CYCLING),
  greenock: [].concat(ALL, RUN, RUN_10K, RUN_HM),
  inverness: [].concat(ALL, RUN, RUN_10K),
  ipswich: [].concat(RUN_ALL, CYCLING, ...TRI_SHORT),
  'kingston-upon-hull': [].concat(ALL, RUN, RUN_HM, TRI),
  leeds: [].concat(RUN_ALL, CYCLING, TRI),
  leicester: [].concat(RUN_MIDDLE, CYCLING, ...TRI_SHORT, OCR, DUATHLON),
  lisburn: [].concat(RUN_SHORT),
  liverpool: [].concat(RUN_LONG, CYCLING, TRI, OCR),
  london: [].concat(RUN_ALL, CYCLING, ...TRI_SHORT, TRI_OLYMPIC, OCR, SWIMMING, MTB, DUATHLON),
  luton: [].concat(RUN_ALL, CYCLING, ...TRI_SHORT, TRI_OLYMPIC, SWIMMING, DUATHLON),
  manchester: [].concat(RUN_ALL, CYCLING),
  middlesbrough: [].concat(RUN_LONG, CYCLING, ...TRI_SHORT),
  newcastle: [].concat(RUN_MIDDLE),
  norwich: [].concat(RUN_MIDDLE, CYCLING),
  nottingham: [].concat(RUN_ALL, CYCLING, ...TRI_SHORT, OCR),
  oxford: [].concat(RUN_ALL, CYCLING, TRI, OCR, DUATHLON),
  penzance: [].concat(ALL, RUN, CYCLING),
  perth: [].concat(ALL, RUN),
  peterborough: [].concat(RUN_MIDDLE, TRI, DUATHLON),
  plymouth: [].concat(RUN_LONG, SWIMMING),
  portsmouth: [].concat(RUN_LONG, CYCLING),
  reading: [].concat(RUN_ALL, CYCLING, ...TRI_SHORT, TRI_OLYMPIC, OCR, MTB, DUATHLON),
  scarborough: [].concat(ALL, RUN, RUN_10K, RUN_HM, RUN_MARATHON),
  sheffield: [].concat(RUN_ALL, CYCLING, DUATHLON),
  southampton: [].concat(RUN_LONG, CYCLING, TRI),
  'southend-on-sea': [].concat(RUN_LONG, CYCLING, TRI, OCR, DUATHLON),
  stoke: [].concat(RUN_ALL, CYCLING, ...TRI_SHORT, OCR),
  sunderland: [].concat(RUN_MIDDLE),
  swansea: [].concat(RUN_ALL, ...TRI_SHORT),
  york: [].concat(RUN_ALL, TRI),

  // UK
  'northern-ireland': [].concat(RUN_MIDDLE),
  scotland: [].concat(RUN_ALL, CYCLING, TRI, TRI_SPRINT, TRI_BEGINNER, OCR, SWIMMING, MTB, DUATHLON),
  wales: [].concat(RUN_ALL, CYCLING, TRI, TRI_SPRINT, TRI_BEGINNER, TRI_HI, OCR, DUATHLON),

  // US locations
  'akron-ohio': [].concat(RUN_LONG),
  'albuquerque-new-mexico': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'alexandria-virginia': [].concat(RUN_LONG),
  'anaheim-california': [].concat(RUN_LONG),
  'arlington-texas': [].concat(RUN_SHORT),
  'atlanta-georgia': [].concat(RUN_MIDDLE),
  'augusta-georgia': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'aurora-colorado': [].concat(RUN_LONG),
  'aurora-illinois': [].concat(RUN_SHORT),
  'austin-texas': [].concat(RUN_SHORT),
  'bakersfield-california': [].concat(ALL, RUN_5K, RUN_BEGINNER, RUN),
  'baltimore-maryland': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_HM),
  'baton-rouge-louisiana': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'bellevue-washington': [].concat(RUN_LONG),
  'birmingham-alabama': [].concat(RUN_SHORT),
  'boise-idaho': [].concat(RUN_MIDDLE),
  'boston-massachusetts': [].concat(RUN_MIDDLE),
  'bridgeport-connecticut': [].concat(RUN_MIDDLE),
  'buffalo-new-york': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'cape-coral-florida': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'carrollton-texas': [].concat(RUN_MIDDLE),
  'cary-north-carolina': [].concat(RUN_SHORT),
  'chandler-arizona': [].concat(RUN_MIDDLE),
  'charlotte-north-carolina': [].concat(RUN_MIDDLE),
  'chattanooga-tennessee': [].concat(RUN_LONG),
  'chesapeake-virginia': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_HM),
  'chicago-illinois': [].concat(RUN_LONG),
  'chula-vista-california': [].concat(RUN_MIDDLE),
  'cincinnati-ohio': [].concat(RUN_SHORT),
  'cleveland-ohio': [].concat(RUN_MIDDLE),
  'colorado-springs-colorado': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_MARATHON),
  'columbus-georgia': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'columbus-ohio': [].concat(RUN_SHORT),
  'corona-california': [].concat(RUN_MIDDLE),
  'corpus-christi-texas': [].concat(ALL, RUN),
  'dallas-texas': [].concat(RUN_MIDDLE),
  'dayton-ohio': [].concat(RUN_MIDDLE),
  'denton-texas': [].concat(RUN_MIDDLE),
  'denver-colorado': [].concat(RUN_LONG),
  'des-moines-iowa': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'detroit-michigan': [].concat(RUN_MIDDLE),
  'durham-north-carolina': [].concat(RUN_SHORT),
  'el-paso-texas': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'elk-grove-california': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, OCR),
  'escondido-california': [].concat(RUN_MIDDLE),
  'eugene-oregon': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_HM),
  'fayetteville-north-carolina': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'fontana-california': [].concat(RUN_MIDDLE),
  'fort-collins-colorado': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'fort-lauderdale-florida': [].concat(RUN_MIDDLE),
  'fort-wayne-indiana': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'fort-worth-texas': [].concat(RUN_SHORT),
  'fremont-california': [].concat(RUN_LONG),
  'fresno-california': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_HM),
  'frisco-texas': [].concat(RUN_MIDDLE),
  'fullerton-california': [].concat(RUN_LONG),
  'garden-grove-california': [].concat(RUN_LONG),
  'garland-texas': [].concat(RUN_MIDDLE),
  'gilbert-arizona': [].concat(RUN_MIDDLE),
  'glendale-arizona': [].concat(RUN_MIDDLE),
  'glendale-california': [].concat(RUN_LONG),
  'grand-prairie-texas': [].concat(RUN_MIDDLE),
  'grand-rapids-michigan': [].concat(RUN_LONG),
  'greensboro-north-carolina': [].concat(RUN_LONG),
  'hayward-california': [].concat(RUN_LONG),
  'henderson-nevada': [].concat(RUN_MIDDLE),
  'hialeah-florida': [].concat(RUN_MIDDLE),
  'hollywood-florida': [].concat(RUN_MIDDLE),
  'honolulu-hawaii': [].concat(ALL, RUN),
  'houston-texas': [].concat(RUN_LONG),
  'huntington-beach-california': [].concat(RUN_LONG, TRI),
  'huntsville-alabama': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_HM),
  'indianapolis-indiana': [].concat(RUN_LONG),
  'irvine-california': [].concat(RUN_LONG),
  'irving-texas': [].concat(RUN_MIDDLE),
  'jacksonville-florida': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'jersey-city-new-jersey': [].concat(RUN_MIDDLE),
  'joliet-illinois': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'kansas-city-kansas': [].concat(RUN_MIDDLE),
  'kansas-city-missouri': [].concat(RUN_MIDDLE),
  'killeen-texas': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'knoxville-tennessee': [].concat(RUN_LONG),
  'lakewood-colorado': [].concat(RUN_LONG),
  'lancaster-california': [].concat(ALL),
  'las-vegas-nevada': [].concat(RUN_LONG),
  'lexington-kentucky': [].concat(RUN_MIDDLE),
  'little-rock-arkansas': [].concat(RUN_SHORT),
  'long-beach-california': [].concat(RUN_LONG, TRI, DUATHLON),
  'los-angeles-california': [].concat(RUN_LONG),
  'louisville-kentucky': [].concat(RUN_SHORT),
  'madison-wisconsin': [].concat(RUN_MIDDLE),
  'mckinney-texas': [].concat(RUN_MIDDLE),
  'memphis-tennessee': [].concat(RUN_SHORT),
  'mesa-arizona': [].concat(RUN_MIDDLE),
  'mesquite-texas': [].concat(RUN_MIDDLE),
  'miami-florida': [].concat(RUN_MIDDLE),
  'milwaukee-wisconsin': [].concat(RUN_MIDDLE),
  'minneapolis-minnesota': [].concat(RUN_SHORT),
  'miramar-florida': [].concat(RUN_MIDDLE),
  'modesto-california': [].concat(RUN_SHORT),
  'moreno-valley-california': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_HM),
  'murfreesboro-tennessee': [].concat(RUN_SHORT),
  'naperville-illinois': [].concat(RUN_LONG),
  'nashville-tennessee': [].concat(RUN_MIDDLE),
  'new-orleans-louisiana': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'new-york-new-york': [].concat(RUN_MIDDLE),
  'newark-new-jersey': [].concat(RUN_MIDDLE),
  'newport-news-virginia': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'norfolk-virginia': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_HM),
  'north-las-vegas-nevada': [].concat(RUN_LONG),
  'oakland-california': [].concat(RUN_LONG, OCR),
  'oceanside-california': [].concat(RUN_MIDDLE),
  'oklahoma-city-oklahoma': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'olathe-kansas': [].concat(RUN_MIDDLE),
  'omaha-nebraska': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'ontario-california': [].concat(RUN_MIDDLE),
  'orange-california': [].concat(RUN_LONG),
  'orlando-florida': [].concat(RUN_MIDDLE),
  'overland-park-kansas': [].concat(RUN_MIDDLE),
  'oxnard-california': [].concat(RUN_LONG),
  'palmdale-california': [].concat(RUN_MIDDLE),
  'pasadena-california': [].concat(RUN_LONG),
  'pasadena-texas': [].concat(RUN_MIDDLE),
  'paterson-new-jersey': [].concat(RUN_MIDDLE),
  'pembroke-pines-florida': [].concat(RUN_MIDDLE),
  'peoria-arizona': [].concat(RUN_MIDDLE),
  'philadelphia-pennsylvania': [].concat(RUN_LONG),
  'phoenix-arizona': [].concat(RUN_MIDDLE),
  'pittsburgh-pennsylvania': [].concat(RUN_SHORT),
  'plano-texas': [].concat(RUN_MIDDLE),
  'pomona-california': [].concat(RUN_LONG),
  'port-st-lucie-florida': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'portland-oregon': [].concat(RUN_LONG),
  'providence-rhode-island': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_HM, RUN_MARATHON),
  'raleigh-north-carolina': [].concat(RUN_SHORT),
  'rancho-cucamonga-california': [].concat(RUN_MIDDLE),
  'reno-nevada': [].concat(ALL),
  'richmond-virginia': [].concat(RUN_LONG),
  'riverside-california': [].concat(RUN_MIDDLE),
  'rochester-new-york': [].concat(RUN_MIDDLE),
  'rockford-illinois': [].concat(RUN_SHORT),
  'roseville-california': [].concat(RUN_MIDDLE, OCR),
  'sacramento-california': [].concat(RUN_SHORT, OCR),
  'saint-paul-minnesota': [].concat(RUN_SHORT),
  'saint-petersburg-florida': [].concat(RUN_MIDDLE),
  'salem-oregon': [].concat(RUN_MIDDLE),
  'salinas-california': [].concat(RUN_MIDDLE),
  'salt-lake-city-utah': [].concat(RUN_SHORT),
  'san-antonio-texas': [].concat(RUN_MIDDLE),
  'san-bernardino-california': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_HM),
  'san-diego-california': [].concat(RUN_MIDDLE),
  'san-francisco-california': [].concat(RUN_MIDDLE, OCR),
  'san-jose-california': [].concat(RUN_LONG),
  'santa-ana-california': [].concat(RUN_LONG),
  'santa-clarita-california': [].concat(RUN_MIDDLE),
  'santa-rosa-california': [].concat(RUN_MIDDLE),
  'savannah-georgia': [].concat(RUN_MIDDLE),
  'scottsdale-arizona': [].concat(RUN_MIDDLE),
  'seattle-washington': [].concat(RUN_LONG),
  'shreveport-louisiana': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_HM),
  'sioux-falls-south-dakota': [].concat(ALL, RUN),
  'spokane-washington': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'springfield-massachusetts': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_HM, RUN_MARATHON),
  'springfield-missouri': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'st-louis-missouri': [].concat(RUN_SHORT),
  'stockton-california': [].concat(RUN_SHORT),
  'sunnyvale-california': [].concat(RUN_LONG),
  'syracuse-new-york': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'tacoma-washington': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_HM, RUN_MARATHON),
  'tampa-florida': [].concat(RUN_MIDDLE),
  'tempe-arizona': [].concat(RUN_MIDDLE),
  'thornton-colorado': [].concat(RUN_LONG),
  'toledo-ohio': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'torrance-california': [].concat(RUN_LONG),
  'tucson-arizona': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_HM),
  'tulsa-oklahoma': [].concat(RUN_SHORT),
  'vancouver-washington': [].concat(RUN_LONG),
  'virginia-beach-virginia': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'waco-texas': [].concat(RUN_SHORT),
  'warren-michigan': [].concat(RUN_MIDDLE),
  'washington-district-of-columbia': [].concat(RUN_LONG),
  'west-valley-city-utah': [].concat(RUN_SHORT),
  'wichita-kansas': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_HM),
  'winston-salem-north-carolina': [].concat(RUN_SHORT, RUN_MARATHON, RUN_ULTRA),
  'worcester-massachusetts': [].concat(ALL, RUN_5K, RUN_BEGINNER, RUN),
  'yonkers-new-york': [].concat(RUN_MIDDLE),

  // US states
  alabama: [].concat(RUN_ALL),
  arizona: [].concat(RUN_ALL),
  arkansas: [].concat(RUN_MIDDLE),
  california: [].concat(RUN_ALL, CYCLING, ...TRI_SHORT, TRI_OLYMPIC, TRI_HI, OCR, SWIMMING, DUATHLON),
  colorado: [].concat(RUN_ALL),
  connecticut: [].concat(RUN_MIDDLE),
  delaware: [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_HM, RUN_MARATHON),
  florida: [].concat(RUN_ALL),
  georgia: [].concat(RUN_ALL, OCR),
  hawaii: [].concat(ALL, RUN),
  idaho: [].concat(RUN_ALL),
  illinois: [].concat(RUN_ALL, OCR),
  indiana: [].concat(RUN_ALL),
  iowa: [].concat(RUN_MIDDLE),
  kansas: [].concat(RUN_LONG),
  kentucky: [].concat(RUN_ALL),
  louisiana: [].concat(RUN_MIDDLE),
  maine: [].concat(RUN_MIDDLE),
  maryland: [].concat(RUN_ALL),
  massachusetts: [].concat(RUN_LONG),
  michigan: [].concat(RUN_LONG, OCR),
  minnesota: [].concat(RUN_MIDDLE),
  mississippi: [].concat(RUN_MIDDLE),
  missouri: [].concat(RUN_MIDDLE),
  montana: [].concat(RUN_MIDDLE, RUN_ULTRA),
  nebraska: [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_HM),
  nevada: [].concat(RUN_LONG, OCR),
  'new-hampshire': [].concat(RUN_MIDDLE, RUN_ULTRA),
  'new-jersey': [].concat(RUN_ALL, OCR),
  'new-mexico': [].concat(RUN_LONG),
  'new-york': [].concat(RUN_MIDDLE),
  'north-carolina': [].concat(RUN_ALL),
  ohio: [].concat(RUN_ALL),
  oklahoma: [].concat(RUN_MIDDLE),
  oregon: [].concat(RUN_ALL),
  pennsylvania: [].concat(RUN_ALL, OCR),
  'rhode-island': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_HM, RUN_MARATHON),
  'south-carolina': [].concat(RUN_ALL),
  'south-dakota': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  tennessee: [].concat(RUN_ALL, OCR),
  texas: [].concat(RUN_LONG, OCR),
  utah: [].concat(RUN_MIDDLE, RUN_ULTRA),
  vermont: [].concat(RUN_SHORT),
  virginia: [].concat(RUN_ALL),
  washington: [].concat(RUN_ALL),
  'west-virginia': [].concat(RUN_ALL, OCR),
  wisconsin: [].concat(RUN_LONG),
  wyoming: [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),

  // AU locations
  'adelaide-south-australia': [].concat(RUN_SHORT, RUN_ULTRA, CYCLING, TRI),
  'albury-new-south-wales': [].concat(ALL, RUN),
  'ballarat-victoria': [].concat(ALL),
  'bendigo-victoria': [].concat(ALL, RUN),
  'brisbane-queensland': [].concat(RUN_SHORT, RUN_MARATHON),
  'cairns-queensland': [].concat(ALL, RUN),
  'canberra-australian-capital-territory': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'darwin-northern-territory': [].concat(ALL, RUN),
  'geelong-victoria': [].concat(RUN_SHORT),
  'gold-coast-queensland': [].concat(ALL, RUN),
  'hobart-tasmania': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'launceston-tasmania': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'melbourne-victoria': [].concat(RUN_SHORT),
  'newcastle-new-south-wales': [].concat(ALL, RUN),
  'perth-western-australia': [].concat(RUN_MIDDLE, RUN_ULTRA),
  'sunshine-coast-queensland': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER, RUN_ULTRA, TRI),
  'sydney-new-south-wales': [].concat(RUN_LONG),
  'wollongong-new-south-wales': [].concat(ALL, RUN),

  // AU states
  'australian-capital-territory': [].concat(ALL, RUN, RUN_5K, RUN_BEGINNER),
  'new-south-wales': [].concat(RUN_ALL, CYCLING, OCR, SWIMMING),
  'northern-territory': [].concat(ALL, RUN),
  queensland: [].concat(RUN_ALL, TRI, CYCLING, SWIMMING),
  'south-australia': [].concat(RUN_ALL, CYCLING, TRI, TRI_SPRINT, TRI_BEGINNER),
  tasmania: [].concat(RUN_SHORT),
  victoria: [].concat(RUN_ALL, CYCLING),
  'western-australia': [].concat(RUN_MIDDLE, RUN_ULTRA, CYCLING, TRI),
};

Object.entries(categoriesByLocation).forEach((entry) => {
  const [key, value] = entry;
  if (!Array.isArray(value) || value.map(v => typeof v === 'string').includes(false)) {
    throw new Error(`Categories for ${JSON.stringify(key)} must be an array of strings`);
  }
});

module.exports = categoriesByLocation;



// WEBPACK FOOTER //
// ./app/src/components/Discovery/data/categoriesByLocation.js